import React from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import ReactDOM from 'react-dom';


// let context;
class Bets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            info: [],
            temporal: []
        }
        this.getdata = this.getdata.bind(this);
    }
    componentDidMount() {
        window.scroll(0, 0);
        // this.props.reload();
        let delta =  document.getElementById('refresh');
       if(delta)delta.click();
    }

    getdata(id) {
        //Vou aqui cuando  
        let items = JSON.parse(localStorage.getItem('temporal'));
        let info = JSON.parse(localStorage.getItem('info'));
        
        if (this.state.info) {
            if (this.state.info.ID == id) {
                let temporal = this.state.temporal;
                let info = this.state.info;
                // console.log(res);
                // this.props.addToPrinter(temporal);

                let wrapper = document.createElement('div');
                const Confirm = () => {
                    // let p = 1;
                    let obj = Object.keys(temporal).map((idApuesta) => {

                        return (
                            <div key={idApuesta} style={{ lineHeight: '16px', borderBottom: '1px solid grey', padding: 5 }}>
                                <div style={{ position: 'relative', display: "table-cell", right: 1, color: "#0cd664", fontSize: 18, float: "right" }}>
                                    <span>
                                        {this.props.language(temporal[idApuesta].option).text + " | " + this.props.format(temporal[idApuesta].odd)}
                                    </span>
                                    <small className="d-block pt-3" style={{ position: 'absolute', right: 1 }}>{this.props.language(temporal[idApuesta].status).text}</small>
                                </div>
                                <div style={{ position: "relative", textAlign: "left", top: 10, paddingBottom: 10 }}>
                                    <span style={{ display: "block", fontSize: 15, color: "rgb(255, 255, 255)" }}>
                                        {/* {idApuesta} */}
                                        {temporal[idApuesta].liga}
                                    </span>
                                    <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                                        {temporal[idApuesta].name}
                                    </span>
                                    <div style={{ display: "inline", paddingTop: 10, fontSize: 12 }}>
                                        {moment(temporal[idApuesta].time * 1000).format('MMM DD, YYYY - H:mm')}
                                    </div>
                                    <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                                        {this.props.language(temporal[idApuesta].logro).text}
                                    </span>


                                </div>
                            </div>
                        )
                    });
                    return (
                        <div style={{ height: 'calc(100% - 10px)' }}>

                            <div className="d-flex justify-content-around">
                                <small className="">{moment(info.Fecha * 1000).format('MMM DD, YYYY - H:mm')}</small>
                                <small className="">
                                    {this.props.language().status + ": "}
                                    <span style={{ fontSize: '16px', color: "rgb(12, 214, 100)" }}> {this.props.language(info.Estado).text}</span>

                                </small>

                            </div>
                            <div className="scrollview" style={{ overflowY: 'scroll', paddingRight: 5 }}>
                                {obj}
                            </div>


                            <div style={{ textAlign: 'right' }}>
                                {this.props.language().stake}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + info.Monto.replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                            </div>

                            <div style={{ textAlign: 'right' }}>
                                {this.props.language().win}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + info.Ganancia.replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                            </div>
                        </div>
                    )

                }
                ReactDOM.render(<Confirm />, wrapper);
                let el = wrapper.firstChild;
                swal({

                    title: this.props.language().coupon + " #" + info.ID,
                    content: el,
                    buttons: {
                        cancel: true,
                        confirm: {
                          text: this.props.language().print,
                          value: true,
                          
                          closeModal: true
                        }
                      },
                    
                   
                }).then(resp=>{
                    if(!resp) throw null;
                    window.print();
                });

            }
            else {
                fetch(this.props.api + '/view/model/pccu/id/' + id, { cache: "no-cache" }).then(results => {
                    return results.json();
                }).then(res => {
                    let temporal = res.items;
                    let info = res.info;
                    console.log(res);
                    // this.props.addToPrinter(temporal);

                    let wrapper = document.createElement('div');
                    const Confirm = () => {
                        // let p = 1;
                        let obj = Object.keys(temporal).map((idApuesta) => {

                            return (
                                <div key={idApuesta} style={{ lineHeight: '16px', borderBottom: '1px solid grey', padding: 5 }}>
                                    <div style={{ position: 'relative', display: "table-cell", right: 1, color: "#0cd664", fontSize: 18, float: "right" }}>
                                        <span>
                                            {this.props.language(temporal[idApuesta].option).text + " | " + this.props.format(temporal[idApuesta].odd)}
                                        </span>
                                        <small className="d-block pt-3" style={{ position: 'absolute', right: 1 }}>{this.props.language(temporal[idApuesta].status).text}</small>
                                    </div>
                                    <div style={{ position: "relative", textAlign: "left", top: 10, paddingBottom: 10 }}>
                                        <span style={{ display: "block", fontSize: 15, color: "rgb(255, 255, 255)" }}>
                                            {/* {idApuesta} */}
                                            {temporal[idApuesta].liga}
                                        </span>
                                        <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                                            {temporal[idApuesta].name}
                                        </span>
                                        <div style={{ display: "inline", paddingTop: 10, fontSize: 12 }}>
                                            {moment(temporal[idApuesta].time * 1000).format('MMM DD, YYYY - H:mm')}
                                        </div>
                                        <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                                            {this.props.language(temporal[idApuesta].logro).text}
                                        </span>


                                    </div>
                                </div>
                            )
                        });
                        return (
                            <div style={{ height: 'calc(100% - 10px)' }}>

                                <div className="d-flex justify-content-around">
                                    <small className="">{moment(info.Fecha * 1000).format('MMM DD, YYYY - H:mm')}</small>
                                    <small className="">
                                        {this.props.language().status + ": "}
                                        <span style={{ fontSize: '16px', color: "rgb(12, 214, 100)" }}> {this.props.language(info.Estado).text}</span>

                                    </small>

                                </div>
                                <div className="scrollview" style={{ overflowY: 'scroll', paddingRight: 5 }}>
                                    {obj}
                                </div>


                                <div style={{ textAlign: 'right' }}>
                                    {this.props.language().stake}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + info.Monto.replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                </div>

                                <div style={{ textAlign: 'right' }}>
                                    {this.props.language().win}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + info.Ganancia.replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                </div>
                            </div>
                        )

                    }
                    ReactDOM.render(<Confirm />, wrapper);
                    let el = wrapper.firstChild;
                    swal({

                        title: this.props.language().coupon + " #" + info.ID,
                        content: el,
                        buttons: {
                            cancel: true,
                            confirm: {
                              text: this.props.language().print,
                              value: true,
                              
                              closeModal: true
                            }
                          },
                       
                    }).then(resp=>{
                        if(!resp) throw null;
                        window.print();
                    });

                    localStorage.setItem('temporal', JSON.stringify(temporal));
                    localStorage.setItem('info', JSON.stringify(info));
                    this.setState({
                        temporal, info
                    });
                });
            }
        }
    }

    render() {
        // document.getElementById('refresh').click();
        let tq = this.props.user.login ? this.props.user.userdata : { Tickets: [], Movimientos: [] };


        let movimientos = []
        if (this.props.user.login) {
            movimientos = tq.Movimientos.map(obj => {

                // let timess = new Date(obj.Fecha * 1000);

                return (
                    <tr key={"MM" + obj.ID}>
                        <td>{obj.ID}</td>
                        <td>{moment(obj.Fecha * 1000).format('MMM DD, YYYY - H:mm')}</td>
                        <td>{this.props.language(obj.GCUA_Id).text}</td>
                        <td>{obj.Monto}</td>
                        <td className={obj.Estado === "Procesado" ? "Gano" : "Espera"}>{this.props.language(obj.Estado).text}</td>

                    </tr>
                )
            })

        }


        let ultimostikets = []
        if (this.props.user.login) {
            let ra = Object.keys(tq.Tickets);
            if (ra.length > 0)
                ultimostikets = ra.map(of => {
                    let ob = tq.Tickets[of];


                    return (
                        <tr key={"Tk" + ob.Id}>
                            <td>{ob.Id}</td>
                            <td>{moment(ob.Fecha * 1000).format('MMM DD, YYYY - H:mm')}</td>
                            <td>{ob.nEventos}</td>
                            <td>{ob.Monto}</td>
                            <td>{ob.Ganancia}</td>
                            <td className={ob.Estado}>{this.props.language(ob.Estado).text}</td>
                            <td className='btn' >
                                <button title="Ver Ticket" className="btn btn-sm btn-success" onClick={this.getdata.bind(this, ob.Id)}  ><i className="icon sicon-search"></i> </button>
                                {/* <button title="Cobrar Ticket" className="btn botn confirm"> <i className="icon sicon-payout"></i></button> */}

                            </td>
                        </tr>
                    )
                })

        }
        return (
            <div className="centerPanel">
                <div id="proximos" className='mb-3'>
                    <div className="row" >
                        <div className="col-sm-12" >
                            <ul className="nav nav-tabs" id="myTab" role="tablist">

                                <li className="nav-item">
                                    <a className="nav-link active " id="home-tab" data-toggle="tab" href="#one" role="tab" aria-controls="home" aria-selected="true"> {this.props.language().coupon}</a>
                                </li>

                                <li className={tq.auto?"d-none":"nav-item"}>
                                    <a className="nav-link " id="profile-tab" data-toggle="tab" href="#two" role="tab" aria-controls="profile" aria-selected="false">{this.props.language().balance}</a>
                                </li>

                                <li className="nav-item d-none">
                                    <a className="nav-link" id="contact-tab" data-toggle="tab" href="#three" role="tab" aria-controls="contact" aria-selected="false">Opciones</a>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane p-3 fade show active" id="one" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="table-responsive">
                                        <table className="table table-sm table-dark table-hover " style={{ minWidth: 560 }}>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>{this.props.language().date}</th>
                                                    <th>{this.props.language().picks}</th>
                                                    <th>{this.props.language().stake}</th>
                                                    <th>{this.props.language().win}</th>
                                                    <th>{this.props.language().status}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ultimostikets}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="tab-pane p-3 fade " id="two" role="tabpanel" aria-labelledby="profile-tab">
                                    <div className="table-responsive">
                                        <table className="table table-sm table-dark table-hover " style={{ minWidth: 560 }}>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>{this.props.language().date}</th>
                                                    <th>{this.props.language().type}</th>
                                                    <th>{this.props.language().amount}</th>
                                                    <th>{this.props.language().status}</th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {movimientos}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>

                                <div className="tab-pane p-3 fade d-none" id="three" role="tabpanel" aria-labelledby="contact-tab">
                                    <small className='row p-3'>
                                        Te pedimos que, para mayor seguridad, cargues tus documentos a revisión. Esto nos facilita el identificarte en caso de que pierdas el acceso a tu cuenta. También nos ayuda a asegurarnos de que recibas sus regalos y recompensas físicas a tu dirección correcta.
        <br />
                                        <br />
                                        Para obtener una prueba de identificación, envíanos una foto de un documento de identificación, licencia de conducir o pasaporte. Para obtener una prueba de domicilio, envíanos una foto de una factura de servicios públicos fechada dentro de los últimos tres meses y mostrando claramente tu nombre (en .jpg, .png y .gif). Verifica cuidadosamente los requerimientos antes de enviar tus documentos.

    </small>
                                    {/* <div className='mb-0 white-text font-thin d-flex justify-content-between'> */}
                                    <button type="submit" className="btn btn-secondary">Seleccionar prueba de identificación</button>
                                    <br />
                                    <button type="submit" className="btn btn-secondary">Seleccionar prueba de direccion</button>
                                    {/* </div> */}
                                </div>
                            </div>


                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

export default Bets;


// WEBPACK FOOTER //
// ./src/components/Bets.js